import React from "react";
import './custom-slider.style.scss'
export default function CustomSlider({
  list = [],
  selectedOption,
  setSelectedOption,
}) {
  return (
    <div className="lcm-options">
      <div
        className={
          selectedOption.id === list[0].id ? "left-most" : "right-most"
        }
      />
      {list.map((obj) => (
        <h6
          onClick={() => setSelectedOption(obj)}
          className={obj.id === selectedOption.id ? "selected" : ""}
          key={obj.keyId}
        >
          {obj.text}
        </h6>
      ))}
    </div>
  );
}
